import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import Button from '@salesforce/design-system-react/components/button';
import { BrowserRouter as Router, RouteComponentProps, withRouter } from 'react-router-dom';
import AgencyTransaction from '../Shared/AgencyTransaction';
import { PICKUP_RETURN, STANDARD_RETURN, USAGE_TYPE } from '../../util/constants';

interface EventId {
  caseExternalId: string;
  eventId: string;
  caseNumber: string;
  diplayordertype: string;
  isAgencyRecord: boolean;
}

// interface for props that the data table cell is getting default from data table.
export interface Props extends RouteComponentProps {
  children?: FC;
  item?: EventId;
  type?: string;
}

const RecordCaseIdCell: FC<Props> = ({
  item = {
    caseExternalId: null,
    eventId: null,
    caseNumber: null,
    diplayordertype: null,
    isAgencyRecord: false,
  },
  history,
  // type = null,
}) => {
  const { eventId, caseNumber, caseExternalId, diplayordertype } = item;
  const goToOrderDetails = (): void => {
    switch (diplayordertype) {
      case USAGE_TYPE.BILL_ONLY:
        history.push('/OrdersUsageDetails', {
          externalId: caseExternalId,
        });
        break;
      case USAGE_TYPE.EXPENSE_INVENTORY:
        history.push('/inventoryExpenseDetails', {
          externalId: caseExternalId,
        });
        break;
      case PICKUP_RETURN:
        history.push('/inventoryReturnDetails', {
          externalId: caseExternalId,
        });
        break;
      case STANDARD_RETURN:
        history.push('/inventoryReturnDetails', {
          externalId: caseExternalId,
        });
        break;
      case USAGE_TYPE.INVENTORY_REQUEST:
        history.push('/inventoryRequestDetails', {
          externalId: caseExternalId,
        });
        break;
      case 'Rep to Customer':
        history.push('/inventoryTransferDetails', {
          externalId: caseExternalId,
        });
        break;
      case 'Rep to Rep':
        history.push('/inventoryTransferDetails', {
          externalId: caseExternalId,
        });
        break;
      default:
    }
  };

  return (
    <Router>
      <DataTableCell title={eventId || ''}>
        <AgencyTransaction isAgencyRecord={item.isAgencyRecord} />
        <Button label={eventId || caseNumber || 'TBD'} variant="base" onClick={goToOrderDetails} />
      </DataTableCell>
    </Router>
  );
};

export default withRouter(RecordCaseIdCell);
